module.exports = __webpack_public_path__ + "assets/icons/ic_info-6429.svg";